import styled, { css } from 'styled-components'
import { breakpoint } from '@sketch/global-styles'

export const Wrapper = styled.div<{
  isDesktopAndBigger: boolean
}>(
  ({ isDesktopAndBigger }) => css`
    display: flex;
    flex-direction: ${isDesktopAndBigger ? 'row' : 'column'};
    flex: auto;
    min-width: 0;
  `
)

export const DragBar = styled.div(
  ({ theme }) => css`
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;

    /* The DragBar is only 2px wide visually, so we make an invisible */
    /* area of 10px this way its easier to grab it and drag */
    width: 10px;

    opacity: 0;

    &:hover {
      opacity: 1;
    }

    &::before {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      /* This is the visible width part of the DragBar */
      width: 2px;
      height: 100%;
      background-color: ${theme.colors.background.tertiary.B};
    }

    &:active {
      &::before {
        background-color: ${theme.colors.background.tertiary.A};
      }
    }

    /* This will avoid a flickering effect when resizing */
    transition-timing-function: ease-in-out;
    transition-duration: 0.3s;
    transition-property: transform, opacity;
    will-change: transform, opacity;
    z-index: ${theme.zIndex[1]};
  `
)

export const Sidebar = styled.div(
  ({ theme }) => css`
    /*
    We use sticky positioning to ensure the sidebar stays in place when scrolling,
    the height is the viewport height minus the header height, so the sidebar will always be visible.

    FIXME: https://linear.app/sketch/issue/SWEB-1815
    */
    position: sticky;
    top: 0;
    left: 0;

    height: calc(100vh - ${theme.header.height}px);
    overflow: auto;

    padding: 8px;
    background: ${theme.colors.background.secondary.A};

    display: flex;
    flex-direction: column;
    flex-shrink: 0;

    ul {
      list-style: none;
      margin: 0;
      padding: 0;
    }
  `
)

export const Content = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;
  flex: auto;

  min-width: 0;
  margin-bottom: 44px;
  padding-left: 12px;
  padding-right: 12px;

  ${breakpoint('sm')`
    margin-top: 16px;
    padding-left: 24px;
    padding-right: 24px;
  `};

  background: ${({ theme }) => theme.colors.background.secondary.B};

  ${breakpoint('sm')`
        margin-top: 0px;
        padding-top: 16px;
        padding-left: 24px;
        padding-right: 24px;
      `};
`
